<template>
  <v-container>
     <v-dialog v-model="dialogRoute" max-width="500" persistent>
                <v-card class="pa-7" color="#e0e0e0" >
                    <v-card-text class="text-center">
                        <v-avatar color="white" size="90" class="mt-n3">
                            <v-icon color="green" x-large>mdi-check-bold</v-icon>
                        </v-avatar>
                    </v-card-text>
                    <v-card-text class="text-center black--text">{{msg}}. </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn to="/login" style="text-decoration: none;">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

      <v-snackbar v-model="successSnack" :timeout="4000" top color="white">
        <span class="green--text">{{sucMsg}}</span>
      </v-snackbar>


    

      <h3 class="mt-7">My Profile</h3>
      <v-tabs color="#48c074" background-color="transparent">
        <v-tab>General Info</v-tab>
        <v-tab>Settings</v-tab>
        <!-- first tab -->
        <v-tab-item>
            <!-- error display -->
           <p v-if="isError" class="red--text text-center">{{errMsg2}}</p> 
          
          <v-row class="mt-3">
            <v-col cols="12" md="6" sm="12">
              <div class="form-group">
                <label for="name">Name</label>
                <div class="input-group">
                  <input type="text" readonly id="name" class="form-control"  v-model="name">
                </div>
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                <div class="input-group">
                  <input type="text" readonly id="email" class="form-control"  v-model="email">
                </div>
              </div>
              <div class="form-group">
                <label for="phone">Phone Number</label>
                <div class="input-group">
                  <input type="text"  id="phone" class="form-control"  v-model="phone" required>
                </div>
              </div>
              <div class="form-group">
                <label for="name">First Name</label>
                <div class="input-group">
                  <input type="text"  id="fname" class="form-control"  v-model="fname" required>
                </div>
              </div>
              <v-file-input accept='image/*' label="Upload your profile image"  color="#002b49" background-color="#f5f3fc" solo flat dense @change="imageUrl($event)" ref="profileUrl"></v-file-input>
               <p class="green--text mt-n6 pt-0" v-if="disabled">please wait, uploading image...<span class="fa fa-circle-o-notch fa-spin"></span></p>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <div class="form-group">
                <label for="bankname">Bank Name</label>
                <div class="input-group">
                  <input type="text" id="bankname" class="form-control"  v-model="bankname" required>
                </div>
              </div>
              <div class="form-group">
                <label for="accountname">Account Name</label>
                <div class="input-group">
                  <input type="text" id="accountname" class="form-control"  v-model="accountname" required>
                </div>
              </div>
              <div class="form-group">
                <label for="accountnumber">Account Number</label>
                <div class="input-group">
                  <input type="text" id="accountnumber" class="form-control"  v-model="accountnumber" required>
                </div>
              </div>
              <div class="form-group">
                <label for="name">Last Name</label>
                <div class="input-group">
                  <input type="text"  id="lname" class="form-control"  v-model="lname" required>
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="text-center mb-12">
    ``  <button :disabled="loadingImage" type="submit" class="btn" style="background-color:#48c074; color:white" @click="Update($event)" >Update
                <span class="fa fa-circle-o-notch fa-spin" v-if="loading1"></span>
            </button>
          </div>
          
          <hr>
          <!-- Transcations -->
          <h5 class="mt-5" style="color:#48c074">All Investments</h5>
          <v-card class="mb-12">
            <template>
                <v-data-table
                    :headers="headers"
                    :items="Investment"
                    hide-default-footer=""
                    no-data-text='You have no current investments'
                    >
                    <template v-slot:item.action="{ item  }">
                        <v-btn icon color="#48c074" @click="getInvestmentById(item._id)"><v-icon>mdi-chevron-right</v-icon></v-btn>
                    </template>
                    <template v-slot:item.cost="{ item }">
                      <span class="black--text">&#8358;{{item.cost}}</span>
                  </template>
                  <template v-slot:item.roi="{ item }">
                      <span class="black--text">{{item.roi}}%</span>
                  </template>
                </v-data-table>
            </template>
          </v-card>
        </v-tab-item>
        <!-- second tab -->
        <v-tab-item>

          <!-- error display -->
           <p v-if="isError" class="red--text text-center">{{errMsg}}</p> 

          <h5 class="mt-5" style="color:#48c074">Change Password</h5>
          <v-row class="mb-12">
            <v-col cols="12" md="6" sm="12" class="">
              <form style="" class="mt-7">
                <div class="form-group">
                  <label for="oldPassword">Old Password</label>
                  <div class="input-group mb-2" id="">
                    <input :type="show1 ? 'text' : 'password'" class="form-control" v-model="oldPassword" id="oldPassword">
                      <div class="input-group-prepend">
                        <div class="input-group-text pa-0">
                          <v-btn icon>
                            <i class="fa fa-eye-slash" aria-hidden="true" @click="show1 = !show1" v-if="!show1"></i>
                            <i class="fa fa-eye" aria-hidden="true" @click="show1 = !show1" v-if="show1"></i>
                          </v-btn>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="newPassword">New Password</label>
                  <div class="input-group mb-2" id="">
                    <input :type="show2 ? 'text' : 'password'" class="form-control" id="newPassword" v-model="newPassword">
                      <div class="input-group-prepend">
                        <div class="input-group-text pa-0">
                          <v-btn icon>
                            <i class="fa fa-eye-slash" aria-hidden="true" @click="show2 = !show2" v-if="!show2"></i>
                            <i class="fa fa-eye" aria-hidden="true" @click="show2 = !show2" v-if="show2"></i>
                          </v-btn>
                        </div>
                      </div>
                  </div>
                </div>
                
                <button :disabled="isDisabled" type="submit" class="btn mt-2" style="width: 100%; background-color:#48c074; color:white" id="signIn" @click="change($event)" >Change Password
                  <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span>
                </button>

              </form>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      

    
  </v-container>
</template>

<script>
export default {
  data(){
    return{
      name: this.$store.state.auth.logindetails.data.firstname + " " + this.$store.state.auth.logindetails.data.lastname,
      lname: this.$store.state.auth.logindetails.data.lastname,
      fname: this.$store.state.auth.logindetails.data.firstname,
      email: this.$store.state.auth.logindetails.data.email,
      phone: this.$store.state.auth.logindetails.data.phone,
      bankname: this.$store.state.auth.logindetails.data.bank_name,
      accountnumber: this.$store.state.auth.logindetails.data.account_number,
      accountname: this.$store.state.auth.logindetails.data.account_name,
      show1:false,
      show2:false,
      show3:false,
      oldPassword:'',
      newPassword:'',
      dialogRoute: false,
      msg: '',
      errMsg: '',
      isError: false,
      isSuccess: false,
      loading: false,
      loading1: false,
      loadingImage: false,
      headers: [
            {
            text: 'Farm',
            align: 'start',
            sortable: false,
            value: 'name',
            },
            { text: 'Cost', value: 'cost' },
            { text: 'ROI', value: 'roi' },
            { text: 'Duration', value: 'duration' },
            { text: 'Date Added', value: 'date_created' },
            { text: '', value: 'action' },
        ],
        disabled:false,
        profileUrl: this.$store.state.auth.logindetails.data.profile_img_url,
        successSnack: false,
        sucMsg: ''
       
    }
  },
   computed:{
     Profile(){
        return this.$store.state.auth.logindetails.data
      },
      Investment(){
            let user= this.$store.state.farm.investment
            for(let i=0; i<user.length; i++){
                user[i].date_created = user[i].date_created.slice(0, 19).replace('T', ' ')
                user[i].cost = parseFloat(user[i].cost).toFixed(2)
            user[i].cost = user[i].cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
          return user
         },
      isDisabled: function(){
        return this.oldPassword.length == "" || this.newPassword.length == "";
      }
    },
    methods:{
         imageUrl(e){
            if(e.name!==""){
                this.loadingImage=true
                this.disabled = true
                this.$store.dispatch("GetImageUrl", {'file':e})
                .then((success)=>{
                    this.profileUrl = success.data.data
                    this.loadingImage= false
                    this.disabled = false
                })
                .catch(()=>{
                      this.disabled = false
                })
            }
        },
       change(event){
         event.preventDefault()
                this.loading = true
                this.$store.dispatch("ChangePassword",{
                    "oldpassword": this.oldPassword,
                    "newpassword": this.newPassword,
                })
                .then(()=>{
                    window.localStorage.removeItem("token")
                    window.localStorage.removeItem("vuex")
                    this.loading = false
                    this.dialog=false
                    this.msg=`Password Updated Successfully.`
                    this.dialogRoute=true
                    
                })
                .catch((error)=>{
                    this.errMsg=error.response.data.message.toUpperCase()
                    this.loading = false
                    this.isError = true
                })    
       },
       Update(event){
         event.preventDefault()
           this.loadingImage = true
           this.loading1 = true
                this.$store.dispatch("UpdateProfile",{
                    "firstname": this.fname,
                    "lastname": this.lname,
                    "accountname": this.accountname,
                    "accountnumber": this.accountnumber,
                    "bankname": this.bankname,
                    "phone": this.phone,
                    "profileUrl": this.profileUrl 
                })
                .then(()=>{
                    this.loadingImage = false
                    this.loading1 = false
                    this.dialog=false
                    this.successSnack = true
                    this.sucMsg=`Profile Updated Successfully.`
                    this.$store.dispatch("GetLoggedUser", this.$store.state.auth.logindetails.data._id)
                })
                .catch((error)=>{
                    this.successSnack = true
                    this.sucMsg=error.response.data.message.toUpperCase()
                    this.loadingImage = false
                     this.loading1 = false
                }) 
       },
       getInvestmentById(id){
         this.$store.dispatch("GetInvestmentById", id)
          .then(()=>{     
              this.$router.push('/invest/'+id)
          })
          .catch(()=>{
          });
       }
    },
    created(){
      this.$store.dispatch("GetUsersInvestment",{id:this.$store.state.auth.logindetails.data._id})
        .then(()=>{ 
        })
        .catch(()=>{
        });
    }
}
</script>

<style>

</style>